// src/pages/AboutUs.tsx
import React, { useEffect, useRef, useState } from 'react';
import "../components/CSS/AboutUs.css"
import { useTranslation } from 'react-i18next';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState({
    hero: false,
    content: false,
  });
  const [isContentHidden, setIsContentHidden] = useState(false);

  const heroRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    const refs = [
      { key: 'hero', ref: heroRef },
      { key: 'content', ref: contentRef },
    ];

    refs.forEach(({ key, ref }) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [key]: true }));
          }
        },
        { threshold: 0.1 }
      );

      if (ref.current) {
        observer.observe(ref.current);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  useEffect(() => {
    // Only apply scroll logic on desktop (width > 767px)
    const checkIfDesktop = () => window.innerWidth > 767;

    if (!checkIfDesktop()) return;

    const handleScroll = () => {
      if (!checkIfDesktop()) return;

      const heroElement = heroRef.current as HTMLElement | null;
      if (!heroElement) return;

      const heroRect = heroElement.getBoundingClientRect();
      const heroHeight = heroElement.offsetHeight;
      const scrolledThroughHero = -heroRect.top;
      const scrollPercentage = (scrolledThroughHero / heroHeight) * 100;

      // Show content-section when user has scrolled 20% through the hero
      // Hide when scrolled less than 20%
      if (scrollPercentage >= 20) {
        setIsContentHidden(false);
      } else {
        setIsContentHidden(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className="about-main">
      <div ref={heroRef} className={`about-hero ${isVisible.hero ? 'fade-in' : ''}`}>
        <div className="about-hero-overlay"></div>
        <div className="about-head">
          <h1 className="about-title-animated">{t("About")}</h1>
          <div className="about-tag">
            <p>
              {t("Aboutparagraph1")}
            </p>
          </div>
        </div>
      </div>

      <div ref={contentRef} className={`content-section ${isVisible.content ? 'fade-in-up' : ''} ${isContentHidden ? 'hidden-section' : ''}`}>
        <div className="section1-head">
          <h3>
            {t("MissionStatement")}
          </h3>
        </div>
        <div className="section1-body">
          <p>
            {t("Aboutparagraph")}
          </p>
          <p>
            {t("Aboutparagraph2")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
